import * as React from 'react';
import { XCircleIcon } from 'lucide-react';
import { Card, CardContent } from 'components/ui/card';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';

type Ref = {
  toggleOpen: () => void;
}

type Props = {
  defaultOpen?: boolean;
}

export type TruckLastPositionCardRef = Ref

export const TruckLastPositionCard = React.forwardRef<Ref, Props>(({
                                                                     defaultOpen = false,
                                                                   }, ref) => {
  const { invoice } = useInvoiceStore();
  const [open, setOpen] = React.useState(defaultOpen);

  React.useImperativeHandle(ref, () => {
    return {
      toggleOpen: () => setOpen(state => !state),
    };
  }, []);

  if (!open) {
    return null;
  }

  return (
    <Card className={'shadow-lg'}>
      <CardContent className={'py-6 px-6 relative text-[14px] max-w-[300px]'}>
        <button className={'absolute top-1 right-1'} onClick={() => setOpen(false)}>
          <XCircleIcon className={'w-5 h-5 stroke-gray-500'} />
        </button>
        <p className={'font-GilroySemibold text-[16px] mb-1'}>Transportadora</p>
        <p className={'uppercase mb-4'}>{invoice?.carrier?.tradeName}</p>
      </CardContent>
    </Card>
  );
});
TruckLastPositionCard.displayName = 'TruckLastPositionCard';